<template>
  <div class="header header-background" :style="{ backgroundImage: 'url(' + bgImage + ')'}">
    <div class="container">
      <div class="header-body">
        <div class="row align-items-center">
          <div class="col-lg-12">
            <div class="text-center">
              <h1 class="display-1 text-white mb-3">{{ title }}</h1>
              <div class="col-lg-10 m-auto justify-content-center">
                <h2 class="text-white mt-1">{{ subtitle }}</h2>
                <div class="mt-2">
                  <slot></slot>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "page-header",
  props: {
    title: {
      type: String,
      description: "Header title"
    },
    subtitle: {
      type: String,
      description: "Header subtitle"
    },
    bgImage: {
      type: String,
      description: "Header background image"
    }
  }
};
</script>

<style scoped lang="scss">
.header-background {
  background-size: cover;
  background-position: center center;
  padding: 16.5rem 1.5rem 12rem;
  background-color: black;

  .header-body {
    overflow-wrap: break-word;
    word-wrap: break-word;
  }

  h1 {
    line-height: 1.15;
  }

  h2 {
    font-weight: 500;
    font-size: 1.25rem;
    line-height: 1.5;
  }
}

@media (max-width: 575.98px) {
  .header-background {
    padding: 10rem 1.5rem 6rem;

    h1 {
      font-size: 2rem;
    }

    h2 {
      font-size: 1rem;
    }

    .btn {
      display: block;
      margin-right: 0;
    }
  }
}
</style>
